// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { mergeMap, map, filter } from 'rxjs/operators';

// DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
// DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';
// DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
import { SocoHttpService } from '@soco/http';

import { WebApiConfigService } from './core/web-api-config/web-api-config.service';

@Component({
    selector: 'my-app',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {
    username: string = null;

    constructor(
        private webApiConfigService: WebApiConfigService,
        private http: SocoHttpService,
        private config: SocoConfigurationService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
    ) { }

    ngOnInit(): void {
        this.setDocumentTitle();
        console.log("hostname--->"+window.location.hostname);
        // dv-kmi.southernco.com

        // If running locally, load the Web API information from sessionStorage if available.
        if (window.location.hostname === 'localhost') {
            this.webApiConfigService.setConfigWebApiInfo();
            this.initialize(true);
        } else if (window.location.hostname === 'dv-kmi.southernco.com') {
            this.webApiConfigService.setConfigWebApiInfo();
        } else if (window.location.hostname === 'ua-kmi.southernco.com') {
            this.webApiConfigService.setConfigWebApiInfo();
        } else if (window.location.hostname === 'kmi.southernco.com') {
            this.webApiConfigService.setConfigWebApiInfo();
        } else if (window.location.hostname === 'qa-kmi.southernco.com') {
            this.webApiConfigService.setConfigWebApiInfo();
        }
        else {
            this.config.webApiBaseUrl = 'https://ua-kmi.southernco.com/webservices/api';
            this.config.webApiToken = 'ANONYMOUS';
            this.config.coolSecurityToken = 'ANONYMOUS';
            this.webApiConfigService.setConfigWebApiInfo();
        }
    }

    private initialize(shouldIgnoreErrorResult: boolean): void {
        // DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        this.http.get<any>({
            url: 'Settings',
            shouldIgnoreErrorResult: shouldIgnoreErrorResult
        }).subscribe(result => {
            // DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
            this.config.settings = result.data;
        }, result => {
            // if we are running locally outside of Visual Studio we won't have a cookie from our login
            // so SocoHttpService won't be able to get our token or the base URL for our Web API. Show a
            // modal to the developer prompting them for a token and the base URL for the Web API.
            if (shouldIgnoreErrorResult && window.location.hostname === 'localhost') {
                this.webApiConfigService.openModal(result);
            }
        });

        this.http.get<any>({
            url: 'Account'
        }).subscribe(result => {
            this.username = result.data.username;

            // DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
            this.config.setSetting('Username', result.data.username);
            this.config.setSetting('Roles', result.data.roles);
        });
    }

    private setDocumentTitle(): void {
        const titleSuffix = 'KMICustomerPortal';

        // Update document title using data.title property from the route definition
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => {
                let route = this.activatedRoute;
                while (route.firstChild) { route = route.firstChild; }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data))
            .subscribe((event) => this.titleService.setTitle(event['title'] ? event['title'] + ' - ' + titleSuffix : titleSuffix));
    }
}

